import React,{Component} from "react";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import './fullCalendar.css';
import AllEvents from '../AllEvents';
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment';
import 'moment/locale/he';

export default class MuseumsEventsCal extends Component{
    
    constructor(props) {
        super(props);
        this.state = {
            calendarWeekends:true,
            items:this.props.data,
            calendarEvents:[],
            eventsFilteredByMonth:[],
            eventsFilteredByDropDown:[],        
            isdisabled:true,
            eventsDisplayTitle:"אירועי החודש",
            dropDownSelectedSort:"אירועי החודש",
            tablet: window.innerWidth < 992,
            mobile: window.innerWidth < 620
        }
        window.addEventListener("resize", this.resize.bind(this));
    }

    calendarRef= React.createRef();

    resize(){
        let tablet= window.innerWidth < 992;
        let mobile= window.innerWidth < 620;
        if(mobile !== this.state.mobile || tablet !== this.state.tablet){
            this.setState({mobile:mobile,
            tablet:tablet})
        }
    }


    componentDidMount() {
        let reduceEventsDates = (events,event)=>{ 
                        let eventMuseumStartDate = moment(event.MuseumEventStartDate).format('YYYY-MM-DD');
                        let eventMuseumEndDate = moment(event.MuseumEventEndDate).add(1,'days').format('YYYY-MM-DD');
                        let myMuseumEventType = event.MuseumEventType;
                        
                        events[event.ID]=
                        { // here we control the events display- i changed so if there is no title we won't see null  -----GAL CHANGES------
                            title: myMuseumEventType ? myMuseumEventType : "",
                            start:eventMuseumStartDate,
                            end:eventMuseumEndDate,
                            className:"date_"+eventMuseumStartDate,
                            extendedProps:{
                                department:"museumEvents"
                            },
                            textColor: '#1b4e79'
                        }
                        return events;
        }

        let items4Cal = this.state.items.reduce(reduceEventsDates,{});
        items4Cal = Object.values(items4Cal);  
        this.updateCalendarEvents();
        this.setState({calendarEvents:items4Cal});
    }

    render(){
        let eventsselect=[];
        let dropDownEventsSorted = this.state.calendarEvents.reduce((eventsTitles,eventTitle)=>{
            if(eventTitle.title){                
                if(!(eventTitle.title in eventsTitles)){ // new event type doesn't exist
                    eventsTitles[eventTitle.title]=
                    { // here we control the events display- i changed so if there is no title we won't see null  -----GAL CHANGES------
                        title: eventTitle.title
                    }
                }
            }
            return eventsTitles;
        },{});
        dropDownEventsSorted = Object.values(dropDownEventsSorted);   

        eventsselect = dropDownEventsSorted.map((event,idx)=>{
            return  <option key={idx+2} >{event.title}</option>
         });

        eventsselect.splice(0,0,<option key="1" defaultValue >אירועי החודש</option>);
        eventsselect.splice(0,0,<option disabled={this.state.isdisabled} className="defaultOption" key="0" >חיפוש לפי אירוע</option>);
        const elem = (
            <div className= "eventsHeader">
               <span>{this.state.eventsDisplayTitle}</span>
            </div>)
        return (
            <div className="CalCon">
                <div className="selectCont">
                    <i className="fas fa-sort-down"></i>
                    <select id="museSel"                    
                        className="CalendarSelect"                    
                        type="select"
                        name="EventDate"
                        onChange={this.getmatchedItems}>
                        {eventsselect}
                    </select>
                </div>
              
                <FullCalendar
                    defaultView="dayGridMonth"
                    ref={this.calendarRef}  
                    // selectable= 'true'                           
                    customButtons={{
                        prev: {
                            text: 'הבא',
                            click: () => {
                            this.calendarRef.current.calendar.next();
                            this.updateCalendarEvents(); }
                        },
                        next: {
                            text: 'קודם',
                            click: () => {
                             this.calendarRef.current.calendar.prev(); 
                             this.updateCalendarEvents();}
                        }
                    }}    
                    header={{
                        left: "prev",
                       center: "title",
                       right:"next"
                    }}
                   
                    views={
                        {
                            dayGridMonth:{
                                titleFormat:{year:'numeric',month:'long'},
                                // locale: 'he',
                                eventLimit:1,
                                eventLimitText:"אירועים",
                                fixedWeekCount: false,
                                showNonCurrentDates: false,
                                handleWindowResize:true,
                                windowResizeDelay: 100,
                                //columnHeader:true,
                                columnHeaderFormat:{weekday:this.state.mobile ? 'short' : 'long'}
                            }
                        }
                    }

                    plugins={[dayGridPlugin, interactionPlugin]}
                    ref={this.calendarRef}
                    events={this.state.calendarEvents}
                    eventClick={this.handleEventClick}
                    dateClick={this.handleDateClick}
                    locale='he'
                    eventBackgroundColor=""
                    eventRender={this.renderEvent}
                    dayRender={this.setCellStyle}
                    height={this.state.mobile ? 380 : (this.state.tablet ? 500 : 770)}
                    //height= {690}
                    
                    eventLimitClick={this.limitClick}
                    contentHeight={'auto'}
                   
                />
                <div className="gridEvents">
                    {elem}
                    {
                         this.state.eventsFilteredByDropDown.map((event, idx) =>  (  
                            <AllEvents key={idx} data={event} />)).sort((a,b) => {            
                                return a.props.data.MuseumEventStartDate < b.props.data.MuseumEventStartDate ? -1 : 1;
                            })
                    }
                </div>
            </div>
        )
    }

    updateCalendarEvents = () =>{
        let filterEventsCurrentMonth = this.filterEventsByMonth(this.state.items);
        let filterEventsCurrentDropDown = this.filterEventsByDropDown(filterEventsCurrentMonth);
        let titleToDisplay = this.updateTitleEvents(filterEventsCurrentDropDown, this.state.dropDownSelectedSort);
        this.setStateFunction(filterEventsCurrentMonth, filterEventsCurrentDropDown, titleToDisplay);
    }
    
    filterEventsByMonth = (allEventsToFilter) => {
        let filterEventsCurrentYear = this.filterEventsByYear(allEventsToFilter);
        let filterEventsCurrentMonth = filterEventsCurrentYear.filter(eve =>{
            return  (moment(eve.MuseumEventEndDate).format('MM') == this.calendarRef.current.calendar.state.dateProfile.currentRange.start.format('MM')) || (moment(eve.MuseumEventStartDate).format('MM') ==this.calendarRef.current.calendar.state.dateProfile.currentRange.start.format('MM'));
        });
        return filterEventsCurrentMonth;
    }

    filterEventsByYear = (allEventsToFilter) => {
        let filterEventsCurrentYear = allEventsToFilter.filter(eve =>{
            return (moment(eve.MuseumEventEndDate).format('YY') == this.calendarRef.current.calendar.state.dateProfile.currentRange.start.format('yy')) || (moment(eve.MuseumEventStartDate).format('YY') ==this.calendarRef.current.calendar.state.dateProfile.currentRange.start.format('yy'));
        });
        
        return filterEventsCurrentYear;
    }

    filterEventsByDropDown = (eventsToSort, dropDownSelected = this.state.dropDownSelectedSort) =>{
        let filterEventsSelectedDD = [];
        if (dropDownSelected == 'אירועי החודש'){
            filterEventsSelectedDD = eventsToSort;    
        }
        else {
            filterEventsSelectedDD = eventsToSort.filter(item => {
                return item.MuseumEventType == dropDownSelected;
            })
        }
        return filterEventsSelectedDD;
    }

    updateTitleEvents = (events, dropDownSelected)=>{
        let eventsDisplayTitleMatchItems = 'אירועי ';
        if (dropDownSelected == 'אירועי החודש'){
            eventsDisplayTitleMatchItems = dropDownSelected;
        }
        else {
            eventsDisplayTitleMatchItems += dropDownSelected;
            if (events.length == 0){
                eventsDisplayTitleMatchItems = "החודש אין אירועי " + dropDownSelected
            }
        }

        return eventsDisplayTitleMatchItems;
    }
    
    getmatchedItems = (info)=>{
        let filterEventsCurrentDropDown = this.filterEventsByDropDown(this.state.eventsFilteredByMonth, info.target.value);
        let titleToDisplay = this.updateTitleEvents(filterEventsCurrentDropDown, info.target.value);
        this.setStateFunction(this.state.eventsFilteredByMonth, filterEventsCurrentDropDown, titleToDisplay, info.target.value.toString(),);
    }

    setStateFunction(eventsFilteredByMonth, eventsFilteredByDropDown, eventsDisplayTitle, dropDownSelectedSort = this.state.dropDownSelectedSort){
        this.setState({eventsFilteredByMonth,
            eventsDisplayTitle,
            dropDownSelectedSort,
            eventsFilteredByDropDown
        });
    }

    handleDateClick = (clickedDate)=>{
        let events;
        let titleToDisplay = "אירועי החודש";
        let eventClickedDate = clickedDate.date;
        let currentDate = moment(eventClickedDate).format('DD.MM.YYYY');
        let eventsMay=[];
        events = this.state.items.filter(eve=>{
            let start = moment(eve.MuseumEventStartDate).format('YYYY-MM-DD');
           
            let end = moment(eve.MuseumEventEndDate).format('YYYY-MM-DD');
            let currentDateEvent = moment(eventClickedDate).format('YYYY-MM-DD');
            return (moment(currentDateEvent).isBetween(start, end) || moment(currentDateEvent).isSame(start) || moment(currentDateEvent).isSame(end));
        })

        if (events.length >0){
            titleToDisplay = "אירועי " + currentDate.toString();
            this.setStateFunction(this.state.eventsFilteredByMonth,events, titleToDisplay);
            $("#"+moment(eventClickedDate).format('YYYY-MM-DD')).css({backgroundColor:'#173d6b'});
            $("#"+moment(eventClickedDate).format('YYYY-MM-DD')).find(".customDate").css({color:'#ffffff','font-weight':'bold'});
            $(".date_" + moment(eventClickedDate).format('YYYY-MM-DD') + " span").css({color:'#ffffff','font-weight':'bold'});
            
        }
        else{ // case the user clicked empty cell it will display "All events"
            this.updateCalendarEvents();
        } 
    }
    

    limitClick = (eventInfo)=>{  
        let eventDateToColorObj = {date: eventInfo.date};
        this.handleDateClick(eventDateToColorObj);
    }


    handleEventClick = (eventInfo)=>{          
        let eventDateToColor = (eventInfo.el.classList[5].slice(eventInfo.el.classList[5].indexOf("_")+1));
        let eventDateToColorObj = {date: eventDateToColor};
        this.handleDateClick(eventDateToColorObj);
    }

    renderEvent = (info)=>{
        let startDate = moment(info.event.start).format('YYYY-MM-DD');
        let endDate = moment(info.event.end).format('YYYY-MM-DD');
        let currentDate = startDate;
        // if (this.calendarRef.current.calendar.state.dateProfile.currentRange.start.format('MM') == moment(currentDate).format('MM')){
            while(moment(currentDate).format('YYYY-MM-DD') < moment(endDate).format('YYYY-MM-DD')){
                let id = moment(currentDate).format('YYYY-MM-DD');
                $("#"+id).css({backgroundColor:'#ededed'});
                $("#"+id).find(".customDate").css({color:'#1b4e79','font-weight':'bold'});
                currentDate= moment(currentDate).add(1,'days');
            }
        //}
        
    }

    setCellStyle= (dayRenderInfo)=>{
        let date = moment(dayRenderInfo.date).format('D');
        dayRenderInfo.el.innerHTML = `<div class='customDateDiv'><span class='customDate'>${date}</span></div>`;
        if(moment(dayRenderInfo.date).format('dd')== 'ש')
        {
            dayRenderInfo.el.style.backgroundColor="#e7eef4";            
        }
        else{
            dayRenderInfo.el.style.backgroundColor="white";
        }
        
        dayRenderInfo.el.id=dayRenderInfo.el.dataset.date;
    }
}
